import { useMutation, useQuery } from "@apollo/client";
import { EXPORT_MISC_APP_CONFIG, GET_SHOWCASE_BANDS, REMOVE_ALL_SHOWCASES } from "./graphql";
import { Box, Button, Stack, Typography } from "@mui/material";
import { PageContainer } from "../../components/PageContainer";
import { LoadingOverlay } from "../../components/Loading";
import { useNavigate } from "react-router-dom";
import { Note } from "../../components/Note";
import { BandPicker } from "../../components/BandPicker";
import { UPDATE_BAND } from "../band/graphql";
import { toast } from "react-toastify";

const ShowcaseBands = () => {
  const navigate = useNavigate();
  const { data, loading, refetch } = useQuery(GET_SHOWCASE_BANDS);
  const [exportShowcases, { loading: updateLoading }] = useMutation(
    EXPORT_MISC_APP_CONFIG,
    {
      onCompleted: (data) => {
        console.log("data", data);
        toast("Showcase section updated");
      },
      onError: () => {
        toast("Error exporting showcase");
      },
    }
  );
  const [removeAllShowcases] = useMutation(
    REMOVE_ALL_SHOWCASES,
    {
      onCompleted: (data) => {
        
        toast("Showcase section updated");
        refetch()
        exportShowcases()
      },
      onError: () => {
        toast("Error removing showcases");
      },
    }
  );

  const [updateBand] = useMutation(UPDATE_BAND, {
    onCompleted: () => {
      refetch();
      toast("Update complete");
    },
  });

  const onAdd = (id: string) => {
    updateBand({
      variables: {
        id: id,
        showcase: true,
      },
    });
  };

  const onRemove = (id: string) => {
    updateBand({
      variables: {
        id: id,
        showcase: false,
      },
    });
  };

  return (
    <PageContainer title="Showcase Bands">
      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={2}
        sx={{
          width: "100%",
          alignItems: { xs: "stretch", md: "center" },
          justifyContent: "space-between",
          flexWrap: "wrap",
          mb: 3,
        }}
      >
        <BandPicker
          controlStyle={{ width: "100%" }}
          placeholder="Add a band"
          handleChange={(id) => {
            onAdd(id);
          }}
          value={undefined}
        />
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          sx={{ width: { xs: "100%", md: "auto" } }}
        >
          <Button
            variant="contained"
            color="error"
            fullWidth
            onClick={() => {
              removeAllShowcases();
            }}
          >
            Remove all & Update
          </Button>
          <Button
            variant="contained"
            fullWidth
            onClick={() => {
              exportShowcases();
            }}
          >
            Update Showcase section
          </Button>
        </Stack>
      </Stack>
      <Note
        message={`Note: these bands will feature prominently within the app, and can be used to draw attention to next years announcements while the app still contains the old lineup.`}
        style={{ marginBottom: 20 }}
      />
      <LoadingOverlay loading={loading}></LoadingOverlay>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(auto-fit, minmax(240px, 1fr))",
          },
          gap: 3,
          width: "100%",
        }}
      >
        {data?.bands.map((item) => (
          <Box
            key={item.id}
            sx={{
              borderRadius: 2,
              border: "1px solid rgba(255,255,255,0.2)",
              p: 2,
              bgcolor: "rgba(255,255,255,0.03)",
              position: "relative",
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                color: !item.description ? "error.main" : "success.light",
                fontWeight: 700,
                mb: 1,
              }}
            >
              {!item.description ? "⚠️ Description missing" : "✅ Description set"}
            </Typography>
            <Box
              component="img"
              src={item.imageUrl ?? ""}
              onClick={() => navigate(`/band/${item.id}`)}
              sx={{
                width: "100%",
                aspectRatio: "1 / 1",
                objectFit: "cover",
                borderRadius: 1,
                cursor: "pointer",
              }}
            />
            <Button
              fullWidth
              color="error"
              variant="contained"
              sx={{ mt: 2 }}
              onClick={() => {
                onRemove(item.id);
              }}
            >
              Remove {item.name}
            </Button>
          </Box>
        ))}
      </Box>
    </PageContainer>
  );
};

export default ShowcaseBands;
